import React from 'react';

/* 
  used in
  #1 /more ==> Menu page from menu ==> ==> menu listing section
*/
function MenuCardListBG({ containerClass, count = 5, hideLabelIcon = false, transparentCard, isSupportMenu = false, largeHeading = false, marginTop= false, hideHeading = false }) {
  return (
    <div className={`${transparentCard ? 'sprint16-myacc-cards3' : 'sprint16-myacc-cards1'} ${containerClass}`}>
      {
        isSupportMenu && !hideHeading && (
          <div className={`sprint16-hedings ${largeHeading ? 'mt-3' : ''} ${marginTop ? 'mt-4' : ''}`}>
        
            <h6 className={`shimmerBG w-30 ${largeHeading ? 'shimmer-text-md' : 'shimmer-text-xs'}`}></h6>
        
            {/* <div className='view-all-link'>
            <a> View All <img src={process.env.PUBLIC_URL + '/assets/images/sprint16/right-arrow-red.svg'} /> </a>
            </div> */}
          </div>
        )
      }

      {
        [...new Array(count)]?.map(
          (el, index) => {
            return (
              <div key={index} className={`sprint16-myacc-card01 ${transparentCard ? 'sprint16-myacc-card03' : 'sprint16-myacc-card01'}`} style={{height : isSupportMenu ? '50px' : ''}}>
                <div className="s16-card01-left w-100">
                  {
                    !hideLabelIcon && (
                    <div className="shimmerBG shimmer-icon-sm" 
                    style={{height: isSupportMenu ? '30px' : '', width: isSupportMenu ? '30px' : ''}}
                    >
                    </div>
                    )
                  }
                  
                  <div className="s16-card01-cont w-85">
                    <h5 className={`shimmerBG shimmer-text-sm mb-2 w-40 ${isSupportMenu ? 'shimmer-text-xs' : 'shimmer-text-sm'}`}></h5>
                    {
                      !isSupportMenu && (
                        <p className='shimmerBG shimmer-text-xs w-100'></p>
                      )
                    }
                  </div>
                </div>
                <div className="right-arrow-btn shimmerBG shimmer-icon-xs">
                </div>
              </div>
            );
          }
        )
      }
    </div>
  );
}

export default MenuCardListBG;
